import PropTypes from 'prop-types'

import { useNavigate } from 'react-router-dom'
import { Auth0Provider } from '@auth0/auth0-react'
import routes from '../../routes'

const { VITE_APP_AUTH0_AUDIENCE, VITE_APP_AUTH0_CLIENT_ID, VITE_APP_AUTH0_DOMAIN } = import.meta.env

const REDIRECT_URI = `${window.location.origin}${routes.authenticated()}`

function Auth0ProviderWithHistory({ children = undefined }) {
  const navigate = useNavigate()

  const onRedirectCallback = () => {
    navigate(routes.authenticated(), { replace: true })
  }

  return (
    <Auth0Provider
      domain={VITE_APP_AUTH0_DOMAIN}
      clientId={VITE_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: REDIRECT_URI,
        audience: VITE_APP_AUTH0_AUDIENCE,
      }}
      onRedirectCallback={onRedirectCallback}
      allowRememberBrowser={false}
    >
      {children}
    </Auth0Provider>
  )
}

Auth0ProviderWithHistory.propTypes = {
  children: PropTypes.node,
}

export default Auth0ProviderWithHistory
